import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App'; // Assuming API is exported from App.js
import { toast } from 'sonner';

const JoinRoomHandler = () => {
  const { inviteCode } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const joinRoom = async () => {
      if (!inviteCode) {
        setError('No invite code provided.');
        setLoading(false);
        toast.error('No invite code provided.');
        navigate('/chat'); // Redirect to chat if no code
        return;
      }

      try {
        setLoading(true);
        let joinIdentifier = inviteCode;
        try {
          const inviteRes = await axios.post(`${API}/invites/resolve/${inviteCode}`);
          if (inviteRes?.data?.room?.id) {
            joinIdentifier = inviteRes.data.room.id;
          }
        } catch {
          // Fallback to legacy invite code format.
        }

        const response = await axios.post(`${API}/rooms/${joinIdentifier}/join`, { invite_code: inviteCode });
        toast.success(response.data.message || `Joined room successfully!`);
        // Redirect to chat page, potentially with the new room selected
        navigate('/chat', { state: { joinedRoomId: response.data.room_id } });
      } catch (err) {
        setError(err.response?.data?.detail || 'Failed to join room.');
        toast.error(err.response?.data?.detail || 'Failed to join room.');
        navigate('/chat'); // Redirect to chat page on error
      } finally {
        setLoading(false);
      }
    };

    joinRoom();
  }, [inviteCode, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        <p className="ml-4 text-gray-700">Joining room...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen text-red-500">
        <p>{error}</p>
      </div>
    );
  }

  return null; // Should redirect before rendering anything else
};

export default JoinRoomHandler;
